function ClosePC () {
  return (
    <>
      <h2 className="screen_out">서비스 안내</h2>
      <section className="wrap_close">
        <img src={require('@assets/images/img_close_pc.png')} alt="" />
        <h3 className="tit_close">서비스 종료</h3>
        <p className="desc_close">
          카카오구독ON 서비스는 종료되었습니다.
          <br />
          더 좋은 서비스로 인사드리겠습니다.
          <br />
          궁금하신 사항은 카카오 고객센터로 문의 부탁드립니다.
        </p>
      </section>
    </>
  );
}

export default ClosePC;
